export default "__VITE_ASSET__BoPdIbUR__"